import env from 'core/env'
export const PAGE_SIZE = env('VITE_PAGE_SIZE', 10)
export const AUTH_TOKEN = 'app/token'
